import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Revenue} from '../../../helpers/Urls';

const INITIAL_STATE = {
  fetchingCustomerData: false,
  hasError: false,
  error: '',
  customerMappedData: null,
  fetchingRegularizationTrackData: false,
  regularizationTrackData: {},
  filters: {},
  regularizationFilter: '',
};

export const SAVE_REGULARIZATION_DATA = 'SAVE_REGULARIZATION_DATA';
export const SAVE_REGULARIZATION_DATA_COMPLETED =
  'SAVE_REGULARIZATION_DATA_COMPLETED';
export const SAVE_REGULARIZATION_DATA_FAILED =
  'SAVE_REGULARIZATION_DATA_FAILED';

export const FETCH_CUSTOMER_MAPPED_INVOICE_DATA =
  'FETCH_CUSTOMER_MAPPED_INVOICE_DATA';
export const FETCH_CUSTOMER_MAPPED_INVOICE_DATA_COMPLETED =
  'FETCH_CUSTOMER_MAPPED_INVOICE_DATA_COMPLETED';
export const FETCH_CUSTOMER_MAPPED_INVOICE_DATA_FAILED =
  'FETCH_CUSTOMER_MAPPED_INVOICE_DATA_FAILED';

export const FETCH_REGULARIZATION_TRACK_DATA =
  'FETCH_REGULARIZATION_TRACK_DATA';
export const FETCH_REGULARIZATION_TRACK_DATA_COMPLETED =
  'FETCH_REGULARIZATION_TRACK_DATA_COMPLETED';
export const FETCH_REGULARIZATION_TRACK_DATA_FAILED =
  'FETCH_REGULARIZATION_TRACK_DATA_FAILED';

export const REGULARIZATION_FILTER = 'REGULARIZATION_FILTER';

export const fetchCustomerMappedInvoiceData = (
  customer_id = null,
  customer_config_id = null,
  invoice_type = null,
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_CUSTOMER_MAPPED_INVOICE_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.fetchCustomerMappedInvoiceDataURL(
          customer_id,
          customer_config_id,
          invoice_type,
        ),
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: FETCH_CUSTOMER_MAPPED_INVOICE_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_CUSTOMER_MAPPED_INVOICE_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_CUSTOMER_MAPPED_INVOICE_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveRegularizationData = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_REGULARIZATION_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.saveRegularizationDataURL(),
        data: requestData,
      });

      const {data, status} = response || {};
      if (status === true) {
        dispatch({type: SAVE_REGULARIZATION_DATA_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SAVE_REGULARIZATION_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_REGULARIZATION_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchRegularizationTrack = (page, search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_REGULARIZATION_TRACK_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.fetchRegularizationTrackURL(page, search),
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: FETCH_REGULARIZATION_TRACK_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_REGULARIZATION_TRACK_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_REGULARIZATION_TRACK_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const appliedRegularizationFilter = (filter = {}, tripStatus = '') => {
  return (dispatch) => {
    dispatch({
      type: REGULARIZATION_FILTER,
      payload: filter,
    });
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case FETCH_CUSTOMER_MAPPED_INVOICE_DATA:
      return {
        ...state,
        fetchingCustomerData: true,
        hasError: false,
        error: '',
      };
    case FETCH_CUSTOMER_MAPPED_INVOICE_DATA_COMPLETED:
      return {
        ...state,
        searching: '',
        fetchingCustomerData: false,
        hasError: false,
        customerMappedData: payload,
      };
    case FETCH_CUSTOMER_MAPPED_INVOICE_DATA:
      return {
        ...state,
        fetchingCustomerData: false,
        hasError: true,
        error: payload.error,
        customerMappedData: null,
      };

    case FETCH_REGULARIZATION_TRACK_DATA:
      return {
        ...state,
        fetchingRegularizationTrackData: true,
        hasError: false,
        error: '',
      };
    case FETCH_REGULARIZATION_TRACK_DATA_COMPLETED:
      return {
        ...state,
        searching: '',
        hasError: false,
        fetchingRegularizationTrackData: false,
        regularizationTrackData: payload,
        filters: payload.filter_dict,
      };
    case FETCH_REGULARIZATION_TRACK_DATA_FAILED:
      return {
        ...state,
        hasError: true,
        error: payload.error,
        fetchingRegularizationTrackData: false,
        regularizationTrackData: {},
      };
    case REGULARIZATION_FILTER:
      return {
        ...state,
        regularizationFilter: payload,
      };

    default:
      return state;
  }
};
